export class DatasheetState {
    name: string = "";
    subName: string = "";
    breadcrumb: string = "";
}